import {createSlice} from "@reduxjs/toolkit";
import saleCommitSaga from "./saleCommitSaga";
import {DATA_LIMIT} from "../../app/constants";

const saleCommit = createSlice({
	name: "saleCommit",
	initialState: {
		loading: false,
        error: null,
		filter:{
			page : 1,
			limit : DATA_LIMIT,
		},
        items: [],
		pagination : {
			page : 1,
			limit : DATA_LIMIT,
			total: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
            state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			let objIndex = state.items.findIndex((item => item.id == action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
	}
})
//Action
export const saleCommitActions = saleCommit.actions;
//Reducers
export const saleCommitReducer = saleCommit.reducer;
//Selectors
export const saleCommitItemsSelector = (state) => state.saleCommit.items;
export const saleCommitLoadingSelector = (state) => state.saleCommit.loading;
export const saleCommitErrorSelector = (state) => state.saleCommit.error;
export const saleCommitFilterSelector = (state) => state.saleCommit.filter;
export const saleCommitPaginationSelector = (state) => state.saleCommit.pagination;